import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { enableRoofToolLines } from 'store/slices/RoofToolLinesSlice';

export function useCancelRoofTool() {
	const dispatch = useDispatch();
	const { selectedFacets, createSpecialEdges, updateSpecialEdges } = useSelector(
		(state: RootState) => state.roofToolLines.data
	);

	const [isModalOpen, setModalOpen] = useState(false);

	const cancelRoofTool = useCallback(() => {
		const newGutterLines = [];
		let hasRemovedGutteLines = false;
	
		for (const [roofSegmentId, { removedGutterLineIds, newAddedGutterLines }] of Object.entries(selectedFacets)) {
			if (newAddedGutterLines?.length) {
				newGutterLines.push(
					...newAddedGutterLines.map((gl) => ({
						roofSegmentId,
						coords: gl.coords,
					}))
				);
			}
	
			hasRemovedGutteLines = !!removedGutterLineIds?.length;
		}
		if (createSpecialEdges.length > 0 || updateSpecialEdges.length > 0 || newGutterLines.length > 0 || hasRemovedGutteLines) {
			setModalOpen(true);
		} else {
			dispatch(enableRoofToolLines({ shouldEnable: false }));
		}
	}, [selectedFacets, createSpecialEdges, updateSpecialEdges, dispatch]);

	const onConfirm = useCallback(() => {
		dispatch(enableRoofToolLines({ shouldEnable: false }));
		setModalOpen(false);
	}, [dispatch]);

	const onCancel = useCallback(() => {
		setModalOpen(false);
	}, []);

	return {
		isModalOpen,
		cancelRoofTool,
		onConfirm,
		onCancel,
	};
}